import classNames from 'classnames/bind';
import styles from './NiceAuth.module.css';
import { useLocation } from 'react-router-dom';
import { apiSlice } from '../../../../services/api';
import { useEffect } from 'react';
import { setLocalStorage } from '../../../../utils/storage';

export default function NiceAuth() {
  const cx = classNames.bind(styles);
  const location = useLocation();
  const params = new (URLSearchParams as any)(location.search);
  const [getAuthNice] = apiSlice.useLazyGetAuthNiceQuery();

  const getAuth = async () => {
    const res = await getAuthNice({
      token_version_id: params.get('token_version_id'),
      enc_data: params.get('enc_data'),
      integrity_value: params.get('integrity_value'),
    }).unwrap();
    const { resultCode, requestNo } = res.data;

    if (resultCode === '0000') {
      setLocalStorage('requestNo', requestNo);
    }
    window.close();
  };

  useEffect(() => {
    getAuth();
  }, []);

  return <></>;
}
